// Verrijkt het CMS-offerteformulier zonder de form-HTML aan te passen:
//  - promoveert bestaande placeholders naar <label> boven het veld
//  - zet daarbinnen een nieuwe, beheerbare voorbeeld-placeholder (via ww_translate)
//  - koppelt for/id voor toegankelijkheid
//  - bouwt de cm-suffix bij Lengte/Breedte
//  - spuit de notitie naast de verstuur-button in
//
// Teksten komen via data-attributes op de wrapper, in Blade gevuld met ww_translate():
//   <div class="offerteformulier"
//        data-note="..."                notitie naast de button
//        data-unit="cm"                 eenheid bij de afmetingen
//        data-select-placeholder="..."  tekst van de eerste (lege) optie
//
//        data-ph-naam="..."             placeholder per veld, gekoppeld op de veld-slug
//        data-ph-email="..."            (= name zonder -<id> en zonder [index])
//        data-ph-telefoon="..."
//        data-ph-vraag-of-opmerkingen="..."
//        data-ph-afmetingen-0="..."     Lengte  (index 0)
//        data-ph-afmetingen-1="..."     Breedte (index 1)
//   >
//
// Ontbreekt een data-ph-* voor een veld, dan blijft de placeholder simpelweg leeg.

class OfferteFormulier {
	constructor(config) {
		this.config = Object.assign({
			scope: '.offerteformulier',
			note: '',
			unit: 'cm',
			selectPlaceholder: ''
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		const self = this;

		this.$scope.each(function () {
			self._enhance($(this));
		});
	}

	_enhance($scope) {
		if ($scope.hasClass('is-enhanced')) {
			return;
		}

		const $form = $scope.find('form').first();

		if ($form.length === 0) {
			return;
		}

		const cfg = {
			note: $scope.attr('data-note') || this.config.note,
			unit: $scope.attr('data-unit') || this.config.unit,
			selectPlaceholder: $scope.attr('data-select-placeholder') || this.config.selectPlaceholder
		};

		this._buildLabels($scope, $form, cfg);
		this._buildDimensions($scope, $form, cfg);
		this._buildButtonNote($form, cfg);

		$scope.addClass('is-enhanced');
	}

	_buildLabels($scope, $form, cfg) {
		const self = this;

		$form.find('.form-group').each(function () {
			const $group = $(this);

			// Afmetingen, submit en de bestaande file-/label-groepen slaan we over
			if ($group.is('.form-group-address, .form-group-submit, .form-group-file, .form-group-label')) {
				return;
			}

			if ($group.find('label.ww-field-label').length > 0) {
				return;
			}

			const $field = $group.find('input, select, textarea').not('[type="hidden"]').first();

			if ($field.length === 0) {
				return;
			}

			let text = '';

			if ($field.is('select')) {
				const $first = $field.find('option').first();
				text = $first.text();

				if (cfg.selectPlaceholder !== '') {
					$first.text(cfg.selectPlaceholder);
				}
			} else {
				// label = originele (al vertaalde) placeholder; daarna beheerbare placeholder erin
				text = $field.attr('placeholder') || '';
				$field.attr('placeholder', self._placeholder($scope, $field.attr('name')));
			}

			text = self._clean(text);

			if (text === '') {
				return;
			}

			const id = self._ensureId($field);

			$('<label>', {
				'class': 'ww-field-label',
				'for': id,
				'text': text
			}).prependTo($group);
		});
	}

	_buildDimensions($scope, $form, cfg) {
		const self = this;
		const $wrap = $form.find('.form-group-address .field-type-address').first();

		if ($wrap.length === 0 || $wrap.hasClass('is-enhanced')) {
			return;
		}

		$wrap.children('input').each(function () {
			const $input = $(this);
			const name = $input.attr('name');
			const text = self._clean($input.attr('placeholder') || '');

			$input.attr('placeholder', self._placeholder($scope, name));

			const id = self._ensureId($input);
			const $col = $('<div>', { 'class': 'address-col' });

			if (text !== '') {
				$('<label>', {
					'class': 'ww-field-label',
					'for': id,
					'text': text
				}).appendTo($col);
			}

			const $unit = $('<div>', { 'class': 'field-unit' });

			$input.before($col); // col op de plek van het input zetten
			$unit.append($input); // input in de unit-wrapper verplaatsen

			if (cfg.unit !== '') {
				$('<span>', { 'class': 'unit-suffix', 'text': cfg.unit }).appendTo($unit);
			}

			$col.append($unit);
		});

		$wrap.addClass('is-enhanced');
	}

	_buildButtonNote($form, cfg) {
		if (cfg.note === '') {
			return;
		}

		const $submit = $form.find('.form-group-submit').first();

		if ($submit.length === 0 || $submit.find('.btn-note').length > 0) {
			return;
		}

		$('<span>', { 'class': 'btn-note', 'text': cfg.note }).appendTo($submit);
	}

	// Beheerbare placeholder ophalen op basis van de veld-slug (+ eventuele array-index)
	//   afmetingen-229[0] -> data-ph-afmetingen-0
	//   naam-205          -> data-ph-naam
	_placeholder($scope, name) {
		const slug = this._slug(name);

		if (slug === '') {
			return '';
		}

		const index = this._index(name);
		const key = index !== null ? ('ph-' + slug + '-' + index) : ('ph-' + slug);

		return $scope.attr('data-' + key) || '';
	}

	_slug(name) {
		return (name || '')
			.replace(/\[\d+\]$/, '') // array-index eraf: [0]
			.replace(/-\d+$/, '')    // CMS-id eraf: -205
			.toLowerCase();
	}

	_index(name) {
		const match = (name || '').match(/\[(\d+)\]$/);

		return match ? match[1] : null;
	}

	// "Ik wil de offerte aanvragen voor een: *" -> "Ik wil de offerte aanvragen voor een *"
	_clean(text) {
		return (text || '').replace(/\s*:\s*(\*)?\s*$/, function (match, star) {
			return star ? ' *' : '';
		}).trim();
	}

	_ensureId($field) {
		let id = $field.attr('id');

		if (!id) {
			const name = ($field.attr('name') || 'field').replace(/[^a-z0-9]+/gi, '-').replace(/-+$/, '');
			id = 'ff-' + name;
			$field.attr('id', id);
		}

		return id;
	}
}

export default new OfferteFormulier;